import { render } from "./TEditor.vue?vue&type=template&id=b9e5d33c&scoped=true"
import script from "./TEditor.vue?vue&type=script&lang=js"
export * from "./TEditor.vue?vue&type=script&lang=js"

import "./TEditor.vue?vue&type=style&index=0&id=b9e5d33c&scoped=true&lang=css"

import exportComponent from "/Users/yinshuangyi/Documents/admin-house/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b9e5d33c"]])

export default __exports__